module.exports = __webpack_public_path__ + "img/ZEL.81dc4f68.svg";